// Skill level definitions with descriptions for user guidance
export const SKILL_LEVELS = [
  {
    value: "Brand New",
    label: "Brand New",
    description: "Learning basics, still need help."
  },
  {
    value: "Beginner",
    label: "Beginner",
    description: "Know the rules, learning strategy."
  },
  {
    value: "Intermediate",
    label: "Intermediate",
    description: "Comfortable playing independently."
  },
  {
    value: "Advanced",
    label: "Advanced",
    description: "Experienced player, strong strategy."
  }
];

// Simple array of skill level values for dropdowns without descriptions
export const SKILL_LEVEL_VALUES = SKILL_LEVELS.map(s => s.value);

// Get color styling for a skill level
export const getSkillLevelColor = (skillLevel) => {
  switch (skillLevel) {
    case "Brand New":
      return { background: "#E3F2FD", color: "#1565C0", border: "#E3F2FD" }; // Blue
    case "Beginner":
      return { background: "#E8F5E9", color: "#2E7D32", border: "#E8F5E9" }; // Green
    case "Intermediate":
      return { background: "#FFF3E0", color: "#E65100", border: "#FFF3E0" }; // Orange
    case "Advanced":
      return { background: "#FFEBEE", color: "#C62828", border: "#FFEBEE" }; // Red
    default:
      return { background: "#F5F5F5", color: "#666", border: "#F5F5F5" }; // Gray
  }
};
